var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Layout,[_c('BaseContent',{staticClass:"content"},[(_setup.loggedIn)?_c(_setup.HomeAuth):_c(_setup.HomeUnAuth)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }